import { ProductMediaTypeEnum } from '../../../../../types/algolia';
import type {
  HoverImageType,
  PrimaryImageType,
} from '~/amplienceTypes/schemas/imported/product-recommendations-schema';

export const srcSizes = [148, 203, 232, 288, 328, 399, 459, 519, 619, 689, 739];
export const DEFAULT_SIZES = '(max-width: 767px) 47vw, (max-width: 1024px) 30vw, 24vw';
export const SPECIAL_MATERIAL_IMAGE = ['Jeans', 'O 5 pockets', 'Col jeans'];

export const ALLOWED_SWATCH_IMAGES = [ProductMediaTypeEnum.M07, ProductMediaTypeEnum.Z07];

/**
 * Profile priority string for G-Star flat product shots, used when a
 * recommendations content item selects the `flat` image type. Ordered by
 * priority: preferred flat shots (E04/F04) first, then broader fallbacks
 * (M04/Z04) and finally the default primary shots (E01/F01) so a tile still
 * renders when no dedicated flat asset exists. On AAF the default primary shot
 * is already flat, so the AAF provider resolves `flat` to its configured
 * primary image types instead of this constant.
 */
export const FLAT_IMAGE_TYPES = [
  ProductMediaTypeEnum.E04,
  ProductMediaTypeEnum.F04,
  ProductMediaTypeEnum.M04,
  ProductMediaTypeEnum.Z04,
  ProductMediaTypeEnum.E01,
  ProductMediaTypeEnum.F01,
].join('|');

/**
 * Named values for the product-recommendations `primaryImageType` /
 * `hoverImageType` selectors. `satisfies` keeps these in sync with the
 * generated schema union, so a schema change surfaces as a type error here.
 */
export const IMAGE_TYPE = {
  defaultPrimary: 'default primary',
  defaultHover: 'default hover',
  flat: 'flat',
} as const satisfies Record<string, PrimaryImageType & HoverImageType>;
